import script from "./navbar-component.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar-component.vue?vue&type=script&setup=true&lang=js"

import "./navbar-component.vue?vue&type=style&index=0&id=5be7d146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be7d146"]])

export default __exports__